<template>
  <div class="row mt-4">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0">Distribución geográfica <span class="geo-badge-hist">{{ periodoLabel }}</span></h6>
              <p class="text-xs opacity-7 mb-0">
                Gráfico agrupado por país · tabla con el desglose por tipster · datos de Meta Ads
              </p>
            </div>
            <div class="btn-group btn-group-sm" role="group">
              <button
                v-for="m in metricas"
                :key="m.key"
                class="btn btn-sm mb-0"
                :class="metrica === m.key ? 'btn-activo' : 'btn-inactivo'"
                @click="metrica = m.key"
              >{{ m.label }}</button>
            </div>
          </div>

          <div v-if="countries.length">
            <!-- Gráfico agrupado por país -->
            <div class="geo-chart mb-4">
              <QuantyBarChart
                id="pub-geo-chart"
                :labels="chartLabels"
                :data="chartData"
                :title="metricaActual.label + ' (por país)'"
                :value-format="metricaActual.format"
                :tooltip-suffix="metricaActual.suffix"
                :use-flags="false"
                :max-items="12"
                :integer-ticks="metricaActual.integer"
                :max-bar-size="18"
                :horizontal="true"
              />
            </div>

            <!-- Tabla desglosada por país + tipster -->
            <div class="geo-table-wrap">
              <table class="table table-flush table-listado table-empirulada">
                <thead class="thead-light">
                  <tr>
                    <th class="th-sort" :class="thClass('country')" @click="setOrden('country')">País</th>
                    <th class="th-sort" :class="thClass('tipster_nombre')" @click="setOrden('tipster_nombre')">Tipster</th>
                    <th class="text-end th-sort" :class="thClass('clicks')" @click="setOrden('clicks')" title="Clics en el enlace del anuncio (Link Clicks de Meta Ads)">Clics</th>
                    <th class="text-end th-sort" :class="thClass('spend')" @click="setOrden('spend')">Gasto (€)</th>
                    <th class="text-end th-sort sin-orden" :class="thClass('impressions')" @click="setOrden('impressions')">Impresiones</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-for="(row, i) in itemsTabla" :key="i">
                    <td>
                      <span v-if="row.country" :class="'fi fi-' + row.country.toLowerCase() + ' fis flag-icon'"></span>
                      <span class="country-name">{{ countryName(row.country) }}</span>
                      <span class="country-iso">({{ row.country }})</span>
                    </td>
                    <td class="td-tipster">{{ row.tipster_nombre }}</td>
                    <td class="text-end">{{ row.clicks.toLocaleString("es-ES") }}</td>
                    <td class="text-end">{{ fmtMoney(row.spend) }}</td>
                    <td class="text-end">{{ row.impressions.toLocaleString("es-ES") }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="!countries.length" class="sin-datos-periodo">
            Sin datos de Meta Ads disponibles
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuantyBarChart from "@/components/charts/QuantyBarChart.vue";

const PAISES = {
  AD: "Andorra", AE: "Emiratos Árabes", AG: "Antigua y Barbuda", AL: "Albania",
  AM: "Armenia", AO: "Angola", AR: "Argentina", AT: "Austria", AU: "Australia",
  AZ: "Azerbaiyán", BA: "Bosnia", BB: "Barbados", BD: "Bangladés", BE: "Bélgica",
  BF: "Burkina Faso", BG: "Bulgaria", BH: "Baréin", BJ: "Benín", BO: "Bolivia",
  BR: "Brasil", BS: "Bahamas", BT: "Bután", BW: "Botsuana", BY: "Bielorrusia",
  BZ: "Belice", CA: "Canadá", CD: "R. D. Congo", CF: "R. Centroafricana",
  CG: "Congo", CH: "Suiza", CI: "Costa de Marfil", CL: "Chile", CM: "Camerún",
  CN: "China", CO: "Colombia", CR: "Costa Rica", CU: "Cuba", CV: "Cabo Verde",
  CY: "Chipre", CZ: "Chequia", DE: "Alemania", DJ: "Yibuti", DK: "Dinamarca",
  DO: "R. Dominicana", DZ: "Argelia", EC: "Ecuador", EE: "Estonia", EG: "Egipto",
  ER: "Eritrea", ES: "España", ET: "Etiopía", FI: "Finlandia", FJ: "Fiyi",
  FR: "Francia", GA: "Gabón", GB: "Reino Unido", GE: "Georgia", GH: "Ghana",
  GM: "Gambia", GN: "Guinea", GQ: "Guinea Ecuatorial", GR: "Grecia",
  GT: "Guatemala", GW: "Guinea-Bisáu", GY: "Guyana", HN: "Honduras",
  HR: "Croacia", HT: "Haití", HU: "Hungría", ID: "Indonesia", IE: "Irlanda",
  IL: "Israel", IN: "India", IQ: "Irak", IR: "Irán", IS: "Islandia",
  IT: "Italia", JM: "Jamaica", JO: "Jordania", JP: "Japón", KE: "Kenia",
  KG: "Kirguistán", KH: "Camboya", KM: "Comoras", KP: "Corea del Norte",
  KR: "Corea del Sur", KW: "Kuwait", KZ: "Kazajistán", LA: "Laos",
  LB: "Líbano", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia",
  LS: "Lesoto", LT: "Lituania", LU: "Luxemburgo", LV: "Letonia", LY: "Libia",
  MA: "Marruecos", MD: "Moldavia", ME: "Montenegro", MG: "Madagascar",
  MK: "Macedonia del Norte", ML: "Malí", MM: "Myanmar", MN: "Mongolia",
  MR: "Mauritania", MT: "Malta", MU: "Mauricio", MV: "Maldivas", MW: "Malaui",
  MX: "México", MY: "Malasia", MZ: "Mozambique", NA: "Namibia", NE: "Níger",
  NG: "Nigeria", NI: "Nicaragua", NL: "Países Bajos", NO: "Noruega",
  NP: "Nepal", NZ: "Nueva Zelanda", OM: "Omán", PA: "Panamá", PE: "Perú",
  PG: "Papúa Nueva Guinea", PH: "Filipinas", PK: "Pakistán", PL: "Polonia",
  PT: "Portugal", PW: "Palaos", PY: "Paraguay", QA: "Catar", RO: "Rumanía",
  RS: "Serbia", RU: "Rusia", RW: "Ruanda", SA: "Arabia Saudí", SB: "Salomón",
  SC: "Seychelles", SD: "Sudán", SE: "Suecia", SG: "Singapur", SI: "Eslovenia",
  SK: "Eslovaquia", SL: "Sierra Leona", SM: "San Marino", SN: "Senegal",
  SO: "Somalia", SR: "Surinam", SS: "Sudán del Sur", ST: "Santo Tomé",
  SV: "El Salvador", SY: "Siria", SZ: "Esuatini", TD: "Chad",
  TG: "Togo", TH: "Tailandia", TJ: "Tayikistán", TL: "Timor Oriental",
  TM: "Turkmenistán", TN: "Túnez", TO: "Tonga", TR: "Türkiye",
  TT: "Trinidad y Tobago", TW: "Taiwán", TZ: "Tanzania", UA: "Ucrania",
  UG: "Uganda", US: "Estados Unidos", UY: "Uruguay", UZ: "Uzbekistán",
  VA: "Vaticano", VC: "San Vicente", VE: "Venezuela", VN: "Vietnam",
  VU: "Vanuatu", WS: "Samoa", XK: "Kosovo", YE: "Yemen", ZA: "Sudáfrica",
  ZM: "Zambia", ZW: "Zimbabue",
};

export default {
  name: "PanelPublicistaGeoMeta",
  components: { QuantyBarChart },
  props: {
    countries: { type: Array, default: () => [] },
    periodo:   { type: String, default: "todo" },
  },
  data() {
    return {
      metrica: "clicks",
      sortCol: "clicks",
      sortDir: "desc",
      metricas: [
        { key: "clicks",      label: "Clics",       format: "number", suffix: " clics", integer: true },
        { key: "spend",       label: "Gasto",       format: "money",  suffix: "",       integer: false },
        { key: "impressions", label: "Impresiones", format: "number", suffix: "",       integer: true },
      ],
    };
  },
  computed: {
    metricaActual() {
      return this.metricas.find(m => m.key === this.metrica) || this.metricas[0];
    },
    periodoLabel() {
      const map = { mes: "Mes actual", "3m": "Últimos 3M", "6m": "Últimos 6M", "12m": "Últimos 12M", todo: "Sin filtro de periodo" };
      return map[this.periodo] || "Sin filtro de periodo";
    },
    // Agrupado por país para el gráfico (suma de todos los tipsters)
    itemsPorPais() {
      const key = this.metrica;
      const map = {};
      for (const r of this.countries) {
        const c = r.country;
        if (!map[c]) map[c] = { country: c, clicks: 0, spend: 0, impressions: 0 };
        map[c].clicks      += Number(r.clicks)      || 0;
        map[c].spend       += Number(r.spend)        || 0;
        map[c].impressions += Number(r.impressions)  || 0;
      }
      return Object.values(map)
        .sort((a, b) => (b[key] || 0) - (a[key] || 0))
        .filter(r => Number(r[key]) > 0)
        .slice(0, 12);
    },
    chartLabels() { return this.itemsPorPais.map(r => this.countryName(r.country)); },
    chartData()   { return this.itemsPorPais.map(r => Number(r[this.metrica]) || 0); },
    // Tabla: desglosada por país + tipster, ordenable
    itemsTabla() {
      const col = this.sortCol;
      const dir = this.sortDir === "asc" ? 1 : -1;
      const isNum = ["clicks", "spend", "impressions"].includes(col);
      return [...this.countries].sort((a, b) => {
        const av = isNum ? (Number(a[col]) || 0) : (a[col] || "").toLowerCase();
        const bv = isNum ? (Number(b[col]) || 0) : (b[col] || "").toLowerCase();
        return av < bv ? -dir : av > bv ? dir : 0;
      });
    },
  },
  methods: {
    countryName(code) {
      return PAISES[String(code || "").toUpperCase()] || code;
    },
    fmtMoney(n) {
      return Number(n || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
    setOrden(col) {
      if (this.sortCol === col) {
        this.sortDir = this.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.sortCol = col;
        this.sortDir = ["clicks", "spend", "impressions"].includes(col) ? "desc" : "asc";
      }
    },
    thClass(col) {
      if (this.sortCol !== col) return "";
      return this.sortDir === "asc" ? "asc" : "desc";
    },
  },
};
</script>

<style scoped>
.geo-chart     { width: 100%; }
.geo-table-wrap{ width: 100%; overflow-x: auto; }

.geo-badge-hist {
  font-size: 10px; font-weight: 600; letter-spacing: .02em;
  background: rgba(245,166,35,.15); color: var(--q-gold);
  border: 1px solid rgba(245,166,35,.3); border-radius: 4px;
  padding: 1px 7px; margin-left: 8px; vertical-align: middle;
}

.flag-icon    { width: 1.2em; height: 1em; margin-right: 6px; vertical-align: middle; }
.country-name { font-size: 13px; font-weight: 500; margin-right: 4px; }
.country-iso  { font-size: 11px; color: var(--q-text-muted); }
.td-tipster   { font-size: 12px; color: var(--q-text-muted); white-space: nowrap; }

.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover { color: var(--q-accent); }

.btn-activo  { background: var(--q-accent); color: #fff; border-color: var(--q-accent); }
.btn-inactivo{ background: transparent; color: var(--q-text-muted); border-color: var(--q-border-md); }
.btn-inactivo:hover { background: var(--q-card-alt); }
.sin-datos-periodo { text-align:center; padding:32px 0; color:var(--q-text-muted); font-size:13px; opacity:.7; }
</style>
